import { theme } from 'antd';

export const THEME_GENERAL = {
    algorithm: theme.defaultAlgorithm,
    cssVar: true,
    token: {
        colorPrimary: '#8D24F8'
    },
    components: {
        Statistic: {
            titleFontSize: 24,
            contentFontSize: 16,
            algorithm: true,
        },
        Select: {
            colorBorder: '#7B7C7D',
            hoverBorderColor: '#8D24F8',
            activeBorderColor: '#8D24F8',

            algorithm: true,
        },
        Table: {
            headerBg: '#F0F3F5',
            rowHoverBg: '#F0F3F5',
            lineWidth: 0,

            algorithm: true,
        },
        Input: {
            colorBgContainer: 'transparent',
            colorBorder: '#7B7C7D',
            colorPrimaryHover: '#7B7C7D',
            borderRadius: 8,
            fontSize: 16,
            paddingBlock: 6,
            algorithm: true,
        },
        Button: {
            defaultHoverColor: '#8D24F8',
            defaultHoverBg: '#8D24F8',
            colorPrimary: '#8D24F8',
            colorLink: '#8D24F8',
            colorPrimaryHover: '#DCFF00',
            primaryColor: '#FFFFFF',
            colorPrimaryTextHover: '#0B0B0C',
            borderRadius: 12,

            algorithm: true,
        },
        Checkbox: {
            colorPrimary: '#8D24F8',
            colorPrimaryHover: '#8D24F8',
            colorPrimaryBorder: '#8D24F8',
        },
        Radio: {
            colorPrimary: '#8D24F8',
            colorPrimaryHover: '#8D24F8',
        },
        Breadcrumb: {
            colorBgTextHover: 'rgba(141,36,248,0.2)',

            algorithm: true,
        },
        Segmented: {
            itemSelectedBg: '#8D24F8',

            algorithm: true,
        },
        Menu: {
            algorithm: true,
        },
    },
};
